import { NeoComponents } from "@forcepoint/platform-utilityui"
import {
  coreStore,
  APP_LOGOUT,
  APP_TENANT,
  clearStorageData
} from "@forcepoint/platform-coreui"
import { useEffect, useState } from "react"
import { setLocalPersistSession } from "../sessionMgmt"

export const SessionAlert = ({
  sessionLogoutTimerData,
  setShowIdleTimeoutAlert
}) => {
  /**
   * To store app messages
   */
  const appMessages = coreStore.getState()?.applicationMessages
  /**
   * To store and set session persistance state
   */
  const [persistSession, setPersistSession] = useState(false)
  const timer = sessionLogoutTimerData * 60
  const [sessionLogoutTimer, setSessionLogoutTimer] = useState(timer)
  // BUG #8: Fix useEffect dependency - was recreating interval every second
  // Changed from [sessionLogoutTimer] (causes interval reset on every tick)
  // to [] so a single interval runs for the component's lifetime. The
  // interval is still cleared when the countdown ends so clearStorageData
  // fires exactly once.
  useEffect(() => {
    //check session validity if it has cookie then valid session
    const interval = setInterval(() => {
      const cookies = document.cookie.split(";")
      // startsWith on the trimmed segment, not includes: a substring match
      // let another tenant's cookie (e.g. supportacme. vs acme. during
      // emulation) satisfy this session-validity check and suppress the
      // idle-timeout teardown.
      const hasAuthCookie = cookies.some((a) =>
        a.trim().startsWith(`${APP_TENANT}cookie.oidc.auth=`)
      )
      setSessionLogoutTimer((val) => {
        if (!hasAuthCookie) {
          clearStorageData(false)
          clearInterval(interval)
          return 0
        }
        if (val <= 0) {
          clearStorageData(false)
          clearInterval(interval)
          return val
        }
        return val - 1
      })
    }, 1000)
    //Clearing the interval
    return () => clearInterval(interval)
  }, [])

  const getDisplayTimer = (time: number): string => {
    const minutes = parseInt(time / 60 + "")
    const seconds = time % 60
    return time > 0
      ? ("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2)
      : ""
  }

  const onContinueSessionClick = () => {
    if (persistSession) {
      setLocalPersistSession(persistSession)
    }
    setShowIdleTimeoutAlert(false)
  }

  return (
    <div className={`fone-alert show-fone-alert`}>
      <div className={`fone-alert-content-medium`}>
        <div className={`fone-alert-icon fone-alert-warning`}>
          <span> </span>
        </div>
        <div className="fone-alert-body">
          <h3 className="fone-alert-title" style={{ marginBottom: "10px" }}>
            Session Timeout
          </h3>
          <span style={{ color: "#97aaba", fontSize: "24px" }}>
            {getDisplayTimer(sessionLogoutTimer)}
          </span>
          <p
            className="fone-alert-para"
            style={{
              fontSize: "14px",
              marginTop: "10px",
              marginBottom: "10px"
            }}
          >
            {sessionLogoutTimer > 0
              ? appMessages?.messages?.header?.USER_IDLE_MSG
              : appMessages?.messages?.header?.USER_SESSION_EXPIRED}
          </p>
        </div>
        {sessionLogoutTimer > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "5px",
              marginBottom: "16px"
            }}
          >
            <NeoComponents.NeoCheckbox
              id="persistSession"
              checked={persistSession}
              onChange={(val) => {
                setPersistSession(val?.target?.checked)
              }}
            ></NeoComponents.NeoCheckbox>{" "}
            <span style={{ fontSize: "12px", color: "#5e778d" }}>
              Do not show me this message again
            </span>
            <div className="fone-alert-footer"></div>
          </div>
        ) : null}
        <div className="fone-alert-footer">
          {sessionLogoutTimer > 0 ? (
            <>
              <NeoComponents.NeoSecondaryButton
                onClick={() => {
                  setPersistSession(false)
                  coreStore.dispatch({ type: APP_LOGOUT })
                  // singleSpa.navigateToUrl("/logout")
                  const closeTab = window.open("", "_self")
                  closeTab.close()
                  setShowIdleTimeoutAlert(false)
                }}
              >
                Logout
              </NeoComponents.NeoSecondaryButton>
              <NeoComponents.NeoPrimaryButton onClick={onContinueSessionClick}>
                Continue
              </NeoComponents.NeoPrimaryButton>
            </>
          ) : (
            <NeoComponents.NeoSecondaryButton
              onClick={() => {
                clearStorageData(false)
                window.location.href = `/platform/login?prompt=login&page=${(
                  window.location.pathname + window.location.hash
                ).slice(1)}`
              }}
            >
              Login Again
            </NeoComponents.NeoSecondaryButton>
          )}
        </div>
      </div>
    </div>
  )
}
